import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  DatePicker,
  Button,
  Form,
  Select,
  Menu,
  Dropdown,
  Checkbox,
  Card,
  Space,
} from 'antd'
import locale from 'antd/es/date-picker/locale/az_AZ'
import SelectField from 'components/SelectField'
import CustomTooltip from 'components/Tooltip'
import SearchInput from 'components/SearchInput'
import { BUTTONS  } from 'constants/constants'
import {TemplateBatchExcel} from 'constants/templateBatchExcel'
import moment from 'moment'

import {
  SearchIco,
  ErrorNotificationIco,
  DownloadIco,
  DropdownIco,
  ClearIcon,
  BlockAccountIco
} from '../../../../modules/CustomIcons'
import './index.scss'
import { useTranslation } from 'react-i18next'
import TableComponent from "components/Table";
import Modal from "components/Modal";
import FileUpload from "components/fileUpload";
import FileUploadXls from "components/FileUploadXls";
import * as XLSX from "xlsx";
import InputField from "components/InputField";
import FileUploadxls from '../component/FileUploadxls'
import { getIpsNonBdgDocumentNumber } from "../../../services/Accounts/DocumentNumber";
import { getCurrentCompany } from "../../../services/user";
import { Account, getAccounts } from "../../../services/account";
import { fillCurrentForm, financial, resetForm } from "../../../services/helper";
import { SelectOptions } from "../../../services/form";
import { createPayment } from "../../../services/MassTransfers/MassTransferFile";
import WarningModal from 'components/WarningModal'
import date from "async-validator/dist-types/validator/date";
import useResponsiveWidth from 'hooks/useResponsiveWidth'


const pageOptions = [10, 50, 100]

const selectOptions = [
  {
    label: 'AZ76BRES00380394402462924501',
    extra: '3 150 952.00 AZN',
    value: 'AZ76BRES00380394402462924501',
  },
  {
    label: 'AZ76BRES00380384002462924535',
    value: 'AZ76BRES00380384002462924535',
    extra: '30.00 USD',
  },
]



const TransfersHeader: React.FC<any> = (props) => {
  const { t } = useTranslation()

  const statusOptions = [
    {
      label: t("common.all"),
      code: '',
      value: 0
    },
    {
      label: t("transfers.waitingForVerification"),
      code: 'BATCH_CHECK_WAITING',
      value: 1

    },
    {
      label: t("transfers.errorsDetectedChecking"),
      value: 2,
      code: 'BATCH_CHECK_ERROR',
    },
    {
      label:  t("transfers.checking"),
      value: 3,
      code: 'BATCH_CHECK_START',
    },
    {
      label: t("transfers.waitingForCreation"),
      value: 4,
      code: 'BATCH_WAITING_CREATE',
    },
    {
      label: t("transfers.errorsCreating"),
      value: 5,
      code: 'BATCH_PAYMENTERROR',
    },
    {
      label: t("transfers.creatingTransfers"),
      value: 6,
      code: 'BATCH_START_CREATE',
    },
    {
      label: t('transfers.CreatedTransfers'),
      value: 7,
      code: 'BATCH_FORPAYMENT',
    },
  ]
  const packageTransferOptions = [
    {
      key: 'OWN_ACCOUNT',
      code: 'IM',
      label: t("transfers.internalToOwnAccount") + (" (IM)"),
    },
    {
      key: 'INTERNAL',
      code: 'IT',
      label: t("templates.internalToOtherBank"),
    },
    {
      key: 'AZIPS',
      code: 'AZ',
      label: t("templates.AZIPS"),
    },
    {
      key: "XOHKS",
      code: "XO",
      label: t("templates.XOKS"),
    },
    {
      key: "DXA",
      code: "XT",
      label: t("templates.budgetSTA"),
    },
    {
      key:'EDV' ,
      code: 'XV',
      label: t("templates.budgetVAT"),
    },
  ]
  const dateFormat = 'DD.MM.YYYY'
  const [diff, setDiff] = useState(false)
  const [startDate, setStartDate] = useState(moment(new Date(), dateFormat))
  const [endDate, setEndDate] = useState(props.endDate)
  const [accountValue, setAccount] = useState(null)
  const [statusValue, setStatus] = useState(null)
  const [searchValue, setValue] = useState('')
  const [checked, setChecked] = useState([]);
  const [modalVisible, setModalVisible] = useState(props.modalVisible)
  const [fileList, setFileList] = useState([])
  const [FileSend, setFileSend] = useState<any[]>([])
  const [packageName, setpackageName] = useState('')
  const [uploadedFile, setUploadedFile] = useState([])
  const [tableDataXls, setTableXls] = useState([])
  const [form] = Form.useForm()
  const [allAccounts, setAllAccounts] = useState([]);
  const [fromBranch, setFromBranch] = useState<Account>();
  const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>();
  const [accOptions, setAccOptionsModal] = useState([])
  const [checkedForService, setcheckedForService] = useState([])

  const [packageNumber, setpackageNumber] = useState([])
  const [fileContent, setFileContent] = useState()
  const [visibleWarning, setVisibleWarning] = useState(false)
  const [errorText,setErrorText] = useState('')
  const [excelFile, setExcelFile] = useState(null);
  const [base64String, setBase64String] = useState('');
  const [packageNameValue, setPackageNameValue] = useState('');
 const [type, setType]=useState('')
 const responsiveWidth = useResponsiveWidth();
  const language = localStorage.getItem("i18nextLng")
  const propsUpload = {
    multiple: false,
    accept: '.xls, .xlsx, .csv',
    maxCount: 1,
    showUploadList: {
      showDownloadIcon: false,
      removeIcon: <div />,
      // maxCount: 1,
      showPreviewIcon: false,
    },
    onRemove: (event, file: any) => {
      event.stopPropagation()
      const index = fileList.indexOf(file)
      const newFileList: any = fileList.slice()
      newFileList.splice(index, 1)
      props.removeFile()
      setpackageName('')
      setPackageNameValue('')
      form.setFieldsValue({"packageName":''})
      return setFileList(newFileList)
    },
    beforeUpload: (file: any) => {
      let fileListArr = []
      fileListArr.push(file)
      setFileList(fileListArr)
      return false
    },
    onChange(info: any) {
      if (info !== undefined && info !== null) {
       
        form.setFieldsValue({
          'packageName': info?.file?.name.replace('.xls','')
        })
        setpackageName(old_value => info?.file?.name.replace('.xls',''))
      }
      console.log(info.file.type)
      if (info.file.type !== 'application/vnd.ms-excel' && info.file.type !== 'text/csv' && info.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        console.log('207')
        setVisibleWarning(true)
        setFileList([])
      } else {
        const listFiles = info.fileList.slice(-3)
        const newArrayFiles = listFiles.map((file: any) =>
          file.originFileObj ? file.originFileObj : file
        )

        const anAsyncFunction = async (item: any) => {

          return convertBase64(item)
        }
        form.setFieldsValue({
          xls_files: info.fileList,
        })
        const getData = async () => {
          return Promise.all(
            newArrayFiles.map((item: any) => anAsyncFunction(item))
          )
        }
        getData().then((data) => {
          setFileSend(data)
        })
      }
    },
    fileList: fileList,
  }

  const convertBase64 = (file: File) => {
    setErrorText('')
   if (file.type === 'text/csv'){
     return new Promise((resolve, reject) => {
       const fileReader = new FileReader();

       fileReader.onload = () => {
         const data = fileReader.result;
         let jsonData;
         try {
           if (file.type === 'text/csv') {

             const textData = new TextDecoder().decode(data as ArrayBuffer);
             const wb = XLSX.read(textData, { type: 'string' });
             console.log(wb)

             const ws = wb.Sheets[wb.SheetNames[0]];
             console.log(ws)
             jsonData = XLSX.utils.sheet_to_json(ws,{header: 1,raw:false,defval:''});
             jsonData = jsonData.map((row) => {
              if (row[9] && typeof row[9] === 'string') {
                row[9] = row[9].replace(/,/g, '.');
              }
              return row;
            });
             console.log(jsonData)
           } else {
             const binaryData = new Uint8Array(data as ArrayBuffer).reduce((data, byte) => {
               return data + String.fromCharCode(byte);
             }, '');
             const wb = XLSX.read(binaryData, { type: 'binary' });
             const ws = wb.Sheets[wb.SheetNames[0]];
             jsonData = XLSX.utils.sheet_to_json(ws);
           }


           if (jsonData && file.type !== 'text/csv') {
             console.log(jsonData)
             const filteredData = jsonData.filter(row => row.__EMPTY !== '' && !isNaN(row.__EMPTY_10));
             if (filteredData.length === 0) {
               setErrorText("error");
             }
             setUploadedFile(jsonData);
             setTableXls(filteredData);
             resolve(jsonData);
           }else{
            console.log(jsonData[0][9]);
             const filteredData = jsonData.filter((row:any) => row[1] !== undefined && (!isNaN(row[9]) || row[9] === undefined) );
             // const filteredData = jsonData.filter((row:any) => console.log(row[1]) );
             const filteredrows = filteredData.map((row:any )=>row.map((item)=>
              item.toString().includes("?") ? item?.toString().replaceAll('?','ə') :item
            //  console.log(item.includes("?")) 
            ) 
            )
             console.log(filteredrows)
             if (filteredData.length === 0) {
               setErrorText("error");
             }
             setUploadedFile(jsonData);
             setTableXls(filteredrows);
             resolve(jsonData);
           }

         } catch (error) {
           setVisibleWarning(true);
           reject(error);
         }
       };

       fileReader.onerror = (error) => {
         reject(error);
       };

       setType(file.type)
       fileReader.readAsArrayBuffer(file);
     });

   }else{
     return new Promise((resolve, reject) => {
       const fileReader = new FileReader()
       fileReader.readAsArrayBuffer(file)
       fileReader.onload = () => {
         var bufferArray = fileReader?.result

         const wb = XLSX.read(bufferArray)
         console.log(wb.SheetNames)
         if (wb.SheetNames[0] === 'Batch' && wb.SheetNames[1] === 'Conditions') {
           const wsname = wb.SheetNames[0]
           const ws = wb.Sheets[wsname]


           const data = XLSX.utils.sheet_to_json(ws)

           if (data[1]?.__EMPTY_12 === 'Ödənişin təyinatı (maks. 140 simv., XT üçün maks. 70 simv.)') {
             setVisibleWarning(true)
           }
           var filteredXls = data.filter((value, index, arr) => {
             return value.__EMPTY !== ''
           })

           var filteredXlsData = data
               .filter(function (value, index, arr) {
                 return !isNaN(value._EMPTY) || !value._EMPTY
               })
               .filter((data) => {
                 return data.__EMPTY !== ''
               })





           if (!('C5' in ws)) {
             setErrorText('')
             setVisibleWarning(true)
           }else if(!('D5' in ws)){
             setErrorText('Excel şablonu doldurulmayıb.')
             setVisibleWarning(true)
           }


           setType(file.type)
           setUploadedFile(filteredXls)
           setTableXls(filteredXlsData)
           resolve(data)
         } else {

           setVisibleWarning(true)

         }


       }
       fileReader.onerror = (error) => {
         reject(error)
       }

       handleConvertClick(file)
     })
   }

};


  const handleConvertClick = async (excelFile: any) => {
    if (excelFile) {
      try {
        const base64: any = await convertToBase64(excelFile);
        setBase64String(base64);
      } catch (error) {
        console.error('Error converting Excel to Base64:', error);
      }
    } else {
      console.warn('Please select an Excel file.');
    }
  };
  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        resolve(event.target.result.split(',')[1]);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  const fetchData = async () => {

    const data = await getAccounts(getCurrentCompany());

    let temp_data = [{ label: t("common.all"), value: '' }];
    let temp_modal = []
    for (let row of data) {
      if (row.CCY_NAME === 'AZN') {
        temp_data.push({
          label: <div className="account_filter_select">
            <div className="account_filter_select__number-row">
              <div className="account_filter_select__number-row--text">{row.NICKNAME ? row.NICKNAME : row.IBAN}</div>
              {
                row.STATUS === "0" ?
                  <CustomTooltip
                    title={t("transfers.closedAccount")}
                  >
                    <Button type={'ghost'} className={'transparent'} icon={<BlockAccountIco className='is_red' />} />
                  </CustomTooltip>
                  : <></>
              }

            </div>
            <div className="is_blue">{financial(row.BALANCE) + " " + row.CCY_NAME}</div>
          </div>,
          value: row.ACCOUNT_NO,
          // extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
          // status:row.STATUS
        });
        {
          if (row.STATUS === "1") {
            temp_modal.push({
              label: <div className="account_filter_select">
            <div className="account_filter_select__number-row">
              <div className="">{row.NICKNAME ? row.NICKNAME : row.IBAN}</div>
            </div>
            <div className="is_blue">{financial(row.BALANCE) + " " + row.CCY_NAME}</div>
          </div>,
              value: row.ACCOUNT_NO,
              // extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
              // status: row.STATUS
            });
          }
        }

      }
    }

    setAllAccounts(data);
    setAccOptionsModal(temp_modal)
    setFromSelectOptions(old_data => temp_data);

    /**/

  };

  const getSelectedFromBranch = async (value: any) => {

    const findAccount = allAccounts?.find(row => row.ACCOUNT_NO == value);

    setFromBranch(findAccount);
    setAccount(findAccount?.IBAN)
  }

  useEffect(() => {

    fetchData();

  }, [modalVisible]);
  // const handleUpload = () => {
  //   let temp_array: Array<any> = []
  //   // const specialCharRegexRu = new RegExp("[а-яА-ЯЁё.!@ ,-]");
  //
  //   // let row = 0; row < tableDataXls.length; row++
  //   tableDataXls.map((row: any, index: number) => {
  //     temp_array.push({
  //       number: index + 1,
  //       key: index + 1,
  //       name: row.__EMPTY_1,
  //       owner: row.__EMPTY_8,
  //       account: row.__EMPTY_2,
  //       amount:
  //           typeof row.__EMPTY_3 == 'string' &&
  //           row.__EMPTY_3.toString().indexOf(',') > -1
  //               ? row.__EMPTY_3.replace(',', '.')
  //               : row.__EMPTY_3,
  //       description: row.__EMPTY_4,
  //       notification: row.__EMPTY_5 && row.__EMPTY_5.length > 180 ? row.__EMPTY_5.substring(0, 180) : row.__EMPTY_5,
  //       status: row.__EMPTY_2,
  //     })
  //   })
  //   console.log(temp_array)
  //   // editTableDataSalary(temp_array)
  //   // setTableDataSalary(uploadedFile)
  // }
  const handleTransferType = (event: any, key: number, item: any) => {


    event.stopPropagation()
    var updatedList = [...checked];
    var trn_type = [...checkedForService]
    if (event.target.checked) {
      updatedList = [...checked, key];
      trn_type = [...checkedForService,item]
    } else {
      updatedList.splice(checked.indexOf(key), 1);
      trn_type.splice(checked.indexOf(item), 1);
    }
    setChecked(updatedList);
    setcheckedForService(trn_type)
  };
  const handleListRemove = (e, key,item) => {
    e.stopPropagation()
    let newChecked = [...checked]
    let trntype =  [...checkedForService]
    setChecked((() => newChecked.filter((item) => key !== item)))
    setcheckedForService((() => trntype.filter((row) => item !== row)))
  }
  var isChecked = (item: number) =>
    checked.includes(item) ? "checked-item" : "not-checked-item";

  const menu = (
    <Menu>
      {packageTransferOptions.map((item, index) => {
        return <Menu.Item key={index}>
          <Checkbox checked={checked.includes(item.code)} onClick={(e) => handleTransferType(e, item.code, item.key)}>{item.label}</Checkbox>
        </Menu.Item>
      })}
    </Menu>
  )
  const handleSearch = (e) => {
    setValue(e.target.value)
  }
  const removeSearch = () => {
    form.resetFields(["search"]);
    setValue('')
  }
  useEffect(() => {
    const diff = moment(endDate).isSameOrAfter(moment(startDate), 'date')
    setDiff(!diff)
  }, [startDate, endDate])
  function downloadExcel() {
    const linkSource = `data:application/vnd.ms-excel;base64,${TemplateBatchExcel}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = 'BatchPayment'
    downloadLink.click()
  }
  const modalFooter = () => {
    return (
      <div className='flex' style={{
        height: 40, position: "absolute",
        right: "25px"
      }}>
        <Button style={{ height: 40 }} className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center " type='ghost' onClick={() => { setModalVisible(false); form.resetFields(['CUSTACC', 'xls_files', 'packageName']); setFileList([]); setFromSelectOptions([]) }}>
          Imtina
        </Button>
        <Button
          disabled={!form.getFieldValue('xls_files') || form.getFieldValue("packageName").length < 3 || form.getFieldValue("packageName").length === 0 || packageName === ''}
          style={{ height: 40, bottom: 0 }}
          className="blue-button next_btn btn flex align_center justify_center blue-buttonnext"
          type='primary' onClick={() => {
            props.onOkCreateTransfer(tableDataXls, fromBranch, form.getFieldValue("packageName"), base64String,type);
            form.resetFields(['CUSTACC1', 'xls_files', 'packageName'])
          }} loading={props.buttonLoading}>
          {t("salary.upload")}
        </Button>
      </div>
    )
  }
  useEffect(() => {
    console.log(props.modalVisible)
    setModalVisible(props.modalVisible)
    setFileList([])
    setpackageName('')
    props.fileList([])
  }, [props.modalVisible === false])

  const removeFileExtension = (fileName: any) => {
    console.log(fileName)
    const lastDotPosition = fileName.replace('.xls', '') || fileName.replace('.xlsx', '');
    console.log(lastDotPosition)
    form.setFieldsValue({
      "packageName": lastDotPosition
    })
    return lastDotPosition
  };
  useEffect(() => {

    setEndDate(props.endDate)
  }, [props.endDate])

  const handleChange = (event: any) => {
    let value = event.target.value
    console.log(value)
    if (event.target.value.includes('xls')) {
      console.log('isledi')
      value = event.target.value.replace('.xls', '') || event.target.value.replace('.xlsx', '') || event.target.value.replace('.csv', '')

    }
    console.log(value.length)
    if (value.length === 0 || value.length < 3) {
      form.setFieldsValue({
        "packageName": ''
      })
      setPackageNameValue('');
      setpackageName('')
    } else {
      form.setFieldsValue({
        "packageName": value.replace('.xls', '')
      })
      setpackageName(value.replace('.xls', ''))

      setPackageNameValue(value?.length > 100 ? value?.substring(0, 100).replace('.xls', '') : value.replace('.xls', ''));
    }
  };


  // @ts-ignore
  return (
    <>
      <Row className="">
        <Col style={{ width: '100%' }}>
          <Row style={{ padding: '20px 30px 0px 0px' }}>
            <Form style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} form={form} className="flex masstransfers-form">
              {/* <div className="flex-column"> */}
              <Col style={{ marginRight: '50px' }} >
                <div className="pickers flex">
                  <label style={{ margin: 'auto 0px' }}>{t("transfers.period")} </label>
                  <div className="flex" style={{ marginLeft: 20 }}>
                    <DatePicker
                      locale={locale}
                      className={diff ? 'errored-ant-picker' : ''}
                      onChange={(e) => { setStartDate(e); props.startDate(e) }}
                      defaultValue={startDate}
                      suffixIcon={null}
                      format={dateFormat}
                      allowClear={false}
                    />

                    {diff && (
                      <CustomTooltip
                        className="error-tooltip"
                        trigger="hover"
                        title={t("transfers.startDateCantBeLaterThanEndDate")}
                      >
                        <div className="error-tooltip__icon" style={{ right: 25, top: 2 }}>
                          <ErrorNotificationIco />
                        </div>
                      </CustomTooltip>
                    )}
                  </div>
                  <span style={{ margin: 'auto 10px' }}>-</span>
                  <div className="flex">
                    <DatePicker
                      locale={locale}
                      defaultPickerValue={moment(new Date())}
                      className={diff ? 'errored-ant-picker' : ''}
                      onChange={(e) => { setEndDate(e); props.changeEndDate(e) }}
                      value={endDate}
                      suffixIcon={null}
                      format={dateFormat}
                      allowClear={false}
                    />
                    {diff && (
                      <CustomTooltip
                        className="error-tooltip"
                        trigger="hover"
                        title={t("transfers.startDateCantBeLaterThanEndDate")}
                      >
                        <div className="error-tooltip__icon" style={{ right: 25, top: 2 }}>
                          <ErrorNotificationIco />
                        </div>
                      </CustomTooltip>
                    )}
                  </div>
                </div>

                <div className='transfers_dropdown'>
                  <Form.Item>
                    <label style={language === "az" ? {width:90} : {width:109}}>{t("transfers.transfertypebatch")}</label>
                    <Dropdown
                      trigger={['click']}
                      overlay={menu}
                      arrow={false}
                    >
                      <Button className="transfers_dropdown__btn" id='dropdown-btn' style={{ left: 27 }}>
                        {checked.length === 0
                       ?  <Space style={{color: '#747A83',marginTop:3}}>{t("common.all")}</Space>:'' } 


                    {checked.length ===1 ||checked.length ===0 ? checked.map((item)=>item) : (','+checked.map((item)=>item)).substring(1)  } <DropdownIco/>
                      </Button>

                    </Dropdown>
                  </Form.Item>
                </div>
              </Col>
              <Col
                style={{
                  marginLeft: 10,
                  minWidth: 480,
                  width: '40%',
                  maxWidth: 540,
                  marginRight: '20px'
                }}>
                <SelectField
                  // open={true}
                  name='status'
                  labelCol={{ flex: '87px' }}
                  labelItem={t("transfers.batchStatus")}
                  placeholder={t("common.all")}
                  value={statusValue}
                  onChange={(value: any) => setStatus(value)}
                  options={statusOptions}
                  defaultActiveFirstOption={false}
                  dropdownClassName="transfers-dropdown -droaccountStatementpdown"
                  // className="labelNoDots filter-select"
                  defaultOpen={true}
                // width={440}
                />
                {/*<SelectField*/}
                {/*  labelItem={t("transfers.fromAccount")}*/}
                {/*  placeholder={t("common.all")}*/}
                {/*  name='CUSTACC'*/}
                {/*  value={fromBranch?.IBAN}*/}
                {/*  onChange={getSelectedFromBranch}*/}
                {/*  dropdownClassName=" masstransfers-select"*/}
                {/*  labelCol={{ flex: '85px' }}*/}
                {/*  className="labelNoDots filter-select"*/}
                {/*  width={440}*/}
                {/*  options={fromSelectOptions}*/}
                {/*/>*/}
                <SelectField
                  name="CUSTACC"
                  labelItem={t("transfers.fromAccount")}
                  placeholder={t("common.all")}
                  options={fromSelectOptions}
                  masstransfer={true}
                  value={fromBranch?.IBAN}
                  onChange={(args: any) => getSelectedFromBranch(args)}
                  defaultActiveFirstOption={false}
                  dropdownClassName="transfers-dropdown accountStatement-dropdown fromAccount-dropdown"
                  optionLabelProp="label"
                  defaultOpen={true}
                  labelCol={{ flex: '85px' }}
                  defaultValue={fromBranch?.IBAN}
                  page={"accountStatement"}
                />
              </Col>

              <Col
                style={{
                  minWidth: 240,
                  width: '30%',
                  maxWidth: 300,
                }}
              >
                
                <Form.Item
                >
                  {/*<div className="flex transfer_search_div">*/}

                  {/*  <SearchInput*/}
                  {/*    labelItem={'Paketin adı'}*/}
                  {/*    value={searchValue}*/}
                  {/*    labelCol={{ flex: '85px' }}*/}
                  {/*    name={'search'}*/}
                  {/*    handleSearch={handleSearch}*/}
                  {/*    removeSearch={removeSearch} />*/}

                  {/*</div>*/}
                  <div className="flex">
                    <InputField
                      labelItem={t("transfers.batchName")}
                      value={searchValue}
                      labelCol={{ flex: '85px' }}
                      name={'search'}
                      placeholder={t("newTransfer.atLeast3Char")}
                      allowClear={true}
                      maxLength={160}
                      className="not-required"
                      required={false}
                    />
                  </div>
                  <div className={'transfer_search_div'}>

                    <Button style={responsiveWidth <=1600 ?{ width:"66%", height: 40 } :{width:215, height: 40 }}  onClick={() => !diff ? props.onClick(startDate, endDate, accountValue, form.getFieldValue('search'), statusValue, checkedForService, statusOptions, packageTransferOptions) :''} loading={props.applyLoading} htmlType="submit" className="blue-button"  >
                      {t("transfers.search")}
                    </Button>
                  </div>
                </Form.Item>
              </Col>

            </Form>
          </Row>
          <ul className='transfer-type'>
            {packageTransferOptions.map((item, index) => {
              return (
                <li key={index} className={isChecked(item.code) == 'checked-item' ? 'transfer-type__list' : ''}>
                  {isChecked(item.code) == 'checked-item' ? <div className='flex'>{item.label}<Button type='ghost' onClick={(e: any, key: number) => handleListRemove(e, item.code,item.key)} icon={<ClearIcon />}></Button></div> : <div />}
                </li>
              )
            }
            )}
          </ul>
        </Col>
      </Row>

      {/* <Divider style={{marginTop: 0, marginBottom:0}} /> */}
      <Col >
        <Row style={{ justifyContent: 'space-between' }} className="masstransfer-btns">
          <div
            className="salary-btns"
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            <Button
              size={'large'}
              htmlType="submit"
              icon={<DownloadIco />}
              onClick={() => downloadExcel()}
              className="light-button refresh_btn btn flex align_center justify_center"
            >
              {BUTTONS.DOWNLOAD_PATTERN}
            </Button>

            <Button
              size={'large'}
              htmlType="submit"
              className="blue-button next_btn btn flex align_center justify_center"
              onClick={() => setModalVisible(true)}
            >
              {t("transfers.uploadBatch")}
            </Button>
          </div>
          <div className="flex pagination-selector">
            <p>{t("transfers.batchesNumberAndPage")} </p>
            <Select defaultValue={10} onChange={props.onSelectChange}>
              {pageOptions.map((item) => {
                return <option value={item}>{item}</option>
              })}
            </Select>
          </div>
        </Row>
        {/* <Divider /> */}
      </Col>
      <Modal
        width={580}
        visible={modalVisible}
        title={BUTTONS.DOWNLOAD_PACKET}
        className="packetmodal"
        footer={modalFooter()}
        // onOk={() => {props.onOkCreateTransfer(tableDataXls,fromBranch?.IBAN,packageName)}}
        onCancel={() => { setModalVisible(false); form.resetFields(['CUSTACC', 'xls_files', 'packageName']); setFileList([]); setFromSelectOptions([]) }}
      >
        <Form

          wrapperCol={{ flex: 1 }}
          className='full'
          form={form}
        >
          {/* <SelectField
            labelItem={t("transfers.fromAccount")}
            

            placeholder={t("accountStatement.chooseAccount")}
            options={accOptions}
            name={'CUSTACC1'}
            onChange={getSelectedFromBranch}
            // required={true}
            form={form}
          // notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
          // defaultValue={ibanNumber.iban}
          /> */}
          <SelectField
                  className="packetmodal-fromAccount"
                  labelItem={t("transfers.fromAccount")}
                  placeholder={t("accountStatement.chooseAccount")}
                  options={accOptions}
                  form={form}
                  name={'CUSTACC1'}
                  masstransfer={true}
                  onChange={(args: any) => getSelectedFromBranch(args)}
                  defaultActiveFirstOption={false}
                  dropdownClassName="transfers-dropdown accountStatement-dropdown"
                  optionLabelProp="label"
                  defaultOpen={true}
                  labelCol={{ flex: '77px' }}
                  defaultValue={fromBranch?.IBAN}
                  page={"accountStatement"}
                />
          <FileUploadxls
            greenUpload
            form={form}
            disabled={!form.getFieldValue('CUSTACC1')}
            fileList={fileList}
            propsUpload={propsUpload}
            onRemove={propsUpload.onRemove}
            convertBase64={convertBase64}
            className="file-upload"
            accept=".xls, .xlsx, .csv"
            // handleUpload={handleUpload}
            // style={{width:355}}
            labelItem={t('salary.chooseFile')}
            name={'xls_files'}

          />
          <WarningModal
            textModal = {errorText}
            visibleModal={visibleWarning}
            onOk={() => { setVisibleWarning(false); form.resetFields(['CUSTACC', 'xls_files', 'packageName']); setFileList([]) }}
            onCancel={() => { setVisibleWarning(false); form.resetFields(['CUSTACC', 'xls_files', 'packageName']); setFileList([])}}
          />
          <div className="flex" style={{ marginTop: 10 }}>

            <InputField
              name="packageName"
              labelItem={t('transfers.batchName')}
              placeholder={t("transfers.atLeast3Char")}
              form={form}
              message={true}
              maxLength={100}
              // allowLatinNumber ={true}
              value={packageName}
              onChange={handleChange}
            />
          </div>
        </Form>


      </Modal>
    </>
  )
}
export default TransfersHeader
